<ion-header class="ion-modal-header" mode="ios">
  <div
    class="modal-header"
    [class.resize-header]="resizeHeader"
    [class.green]="color === 'green'">
    <div class="modal-title-wrapper" [class.text-center]="titleTextCenter">
      <span *ngIf="renderHtml" class="render-title" [innerHtml]="modalTitle"></span>
      <span *ngIf="!renderHtml">{{ modalTitle }}</span>
    </div>
    <div class="close-button" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </div>
  </div>
</ion-header>
<div class="inner-content">
  <div class="modal-content" [style.padding]="modalPadding">
    <ng-content></ng-content>
  </div>
</div>

<ion-footer class="modal-footer border-top" mode="ios">
  <ng-content select="[modalFooter]"></ng-content>
</ion-footer>
